const EnforcementEndpoint = {
  index ({ serial_number }) {
    return {
      url: '/enforcement?serial_number=' + serial_number,
      method: 'GET'
    }
  }
}

export default EnforcementEndpoint



// WEBPACK FOOTER //
// ./src/persistence/EnforcementEndpoint.js